import { CreateObjectiveResult } from '@ospace/schemas/objective'
import { FormInit } from '@ospace/shared'
import dayjs from 'dayjs'

const inits: FormInit<CreateObjectiveResult> = {
  startDate: dayjs().startOf('week').format('YYYY-MM-DD'),
  impressions: 0,
  campaignClicks: 0,
  totalImpressions: '',
  totalCampaignClicks: '',
}

export { inits }
